import { createSvgIcon } from "@mui/material";

const CompleteDialogIcon = createSvgIcon(
  <svg viewBox="0 0 80 80" fill="none">
    <path
      d="M0 21.5335C0 9.75145 9.55126 0.200195 21.3333 0.200195H58.6667C70.4487 0.200195 80 9.75146 80 21.5335V58.8669C80 70.6489 70.4487 80.2002 58.6667 80.2002H21.3333C9.55126 80.2002 0 70.6489 0 58.8669V21.5335Z"
      fill="var(--subtle-surface-bg, #F6F8FA)"
    />
    <path
      d="M42.7033 66.0243C54.7726 66.0243 64.5567 56.2402 64.5567 44.1708C64.5567 32.1015 54.7726 22.3174 42.7033 22.3174C30.634 22.3174 20.8499 32.1015 20.8499 44.1708C20.8499 56.2402 30.634 66.0243 42.7033 66.0243Z"
      fill="#E8EEF2"
    />
    <path
      d="M14.3328 39.4446C14.3328 36.1452 15.0914 32.8741 16.2204 30.1143C16.5456 29.3192 17.4539 28.9385 18.249 29.2636C19.0441 29.5889 19.4254 30.4972 19.1001 31.2923C18.1029 33.73 17.4439 36.6016 17.4439 39.4446C17.4439 50.7526 26.6702 59.9789 37.9782 59.9789C42.6836 59.9789 46.9689 58.3396 50.5111 55.6829C51.1984 55.1675 52.1736 55.3068 52.6891 55.9941C53.2045 56.6814 53.0652 57.6566 52.3779 58.1721C48.3601 61.1854 43.4315 63.09 37.9782 63.09C24.952 63.09 14.3328 52.4708 14.3328 39.4446Z"
      fill="#B4C8D3"
    />
    <path
      d="M60.1034 47.796C59.7975 48.5988 58.8988 49.002 58.096 48.6962C57.2933 48.3903 56.8905 47.4916 57.1962 46.6888L60.1034 47.796ZM58.5118 39.4462C58.5118 28.1383 49.2858 18.912 37.9779 18.9119C33.053 18.9119 28.4315 20.7751 24.9015 23.6432C24.2348 24.1849 23.2549 24.0834 22.7132 23.4167C22.1715 22.7499 22.273 21.77 22.9397 21.2283C26.9699 17.9538 32.2715 15.8008 37.9779 15.8008C51.004 15.8009 61.6229 26.4201 61.6229 39.4462C61.6229 42.3477 61.1173 45.1344 60.1034 47.796L57.1962 46.6888C58.0723 44.3892 58.5118 41.9783 58.5118 39.4462Z"
      fill="#B4C8D3"
    />
    <path
      d="M43.1393 34.1144C43.7405 33.5007 44.7257 33.4907 45.3394 34.0918C45.953 34.693 45.9631 35.6778 45.362 36.2915L36.8247 45.0063C36.5341 45.303 36.1371 45.4712 35.7218 45.4734C35.3065 45.4755 34.9074 45.3117 34.6137 45.0181L30.523 40.9273L30.4679 40.8692C29.9161 40.2586 29.9345 39.3158 30.523 38.7273C31.1305 38.1199 32.1152 38.1199 32.7227 38.7273L35.7018 41.7064L43.1393 34.1144Z"
      fill="#00A866"
    />
  </svg>,
  "CompleteDialogIcon"
);

export default CompleteDialogIcon;
